import { FieldText, ModalBody, ModalFoot } from '@dixa/lib-shared-habla';
import { Field, Form, InjectedFormProps, reduxForm } from 'redux-form';

import { validateName } from 'utils/formValidator';

import { FORM_NAME, validateEditFormStep1 } from '../utils/editAutomationForm';

import styles from './editAutomationForm.module.scss';
import type { EditAutomationModalFormValuesT } from './types';

type EditAutomationFormStep1ImplOwnProps = {
  handleCancel: () => void;
  nextStep: (values: EditAutomationModalFormValuesT) => void;
  confirmName: string;
};

type InjectedProps = InjectedFormProps<
  EditAutomationModalFormValuesT,
  EditAutomationFormStep1ImplOwnProps
>;

type PropsT = EditAutomationFormStep1ImplOwnProps & InjectedProps;

const EditAutomationFormStep1Impl = (props: PropsT): JSX.Element => {
  const { handleSubmit, handleCancel, confirmName, pristine } = props;

  return (
    <Form onSubmit={handleSubmit(props.nextStep)}>
      <ModalBody>
        <Field
          label="Name"
          name="name"
          maxLength="255"
          component={FieldText}
          type="text"
          className={styles.field}
          placeholder="Automation"
          required
          validate={validateName}
        />
        <Field
          label="Description"
          name="description"
          component={FieldText}
          className={styles.field}
          placeholder="What does this automation do? (optional)"
        />
      </ModalBody>
      <ModalFoot
        cancelOnClick={handleCancel}
        cancelName="Cancel"
        confirmOnClick={handleSubmit(props.nextStep)}
        confirmName={confirmName}
        confirmProps={{
          disabled: pristine,
        }}
      />
    </Form>
  );
};

export const EditAutomationFormStep1 = reduxForm<
  EditAutomationModalFormValuesT,
  EditAutomationFormStep1ImplOwnProps
>({
  form: FORM_NAME,
  enableReinitialize: false,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateEditFormStep1,
})(EditAutomationFormStep1Impl);
